// ============================================
// Canonical subject order (PCM / PCMB / PCMC)
// ============================================
// Subject columns and chips must follow the teaching sequence of the student's
// group — Physics, Chemistry, Mathematics, then Biology (PCMB) or Computer
// Science (PCMC) — not alphabetical order and not whatever order the rows
// happen to arrive in.
//
// A student only ever sees their own subjects, so one canonical ranking gives
// the correct per-group order without needing per-group configuration. Biology
// is kept adjacent to Botany and Zoology because Biology is a mix of the two.
// Anything not on the list sorts after the ranked subjects, alphabetically.
//
// This mirrors the SUBJECT_ORDER used server-side for the analytics endpoint in
// server/src/admin/onlineexam/onlineexam.routes.ts — keep the two in step.

export const SUBJECT_ORDER = [
  'physics', 'chemistry', 'mathematics', 'maths', 'biology', 'botany', 'zoology',
  'computer science', 'computers', 'computer',
];

/** Position of a subject in the canonical order; unknown subjects rank last. */
export function subjectRank(name: string): number {
  const i = SUBJECT_ORDER.indexOf(String(name || '').trim().toLowerCase());
  return i === -1 ? SUBJECT_ORDER.length : i;
}

/** Comparator for subject names: canonical order first, then alphabetical. */
export function compareSubjects(a: string, b: string): number {
  return (subjectRank(a) - subjectRank(b)) || String(a).localeCompare(String(b));
}

/** Sort a list of objects by their subject name, in canonical order. */
export function sortBySubjectOrder<T>(items: T[], nameOf: (item: T) => string): T[] {
  return [...items].sort((x, y) => compareSubjects(nameOf(x), nameOf(y)));
}
